import publisherDashboard from './pages/Dashboard/ducks'

const publisherReducer = {
  publisherDashboard,
}

export default publisherReducer
